import { render, staticRenderFns } from "./BannersImg.vue?vue&type=template&id=63add2fd&scoped=true"
import script from "./BannersImg.vue?vue&type=script&lang=js"
export * from "./BannersImg.vue?vue&type=script&lang=js"
import style0 from "./BannersImg.vue?vue&type=style&index=0&id=63add2fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63add2fd",
  null
  
)

export default component.exports